import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';

interface HeaderProps {
  title: string;
  subtitle: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
  backButtonText?: string;
  showLogo?: boolean;
  userName?: string;
  onLogout?: () => void;
}

export const Header = ({
  title,
  subtitle,
  showBackButton = false,
  onBackClick,
  backButtonText = 'Back to Dashboard',
  showLogo = false,
  userName,
  onLogout,
}: HeaderProps) => {
  return (
    <header className="border-b border-border bg-card">
      <div className="flex items-center justify-between h-20 px-6">
        <div className="flex items-center space-x-6">
          {/* Logo and App Name */}
          {showLogo && (
            <Link
              to="/"
              className="flex items-center space-x-3 transition-colors"
            >
              <div className="w-10 h-10 rounded-lg">
                <img
                  src="/assets/nabt-vector.svg"
                  alt="NABT"
                  className="object-contain w-full h-full"
                />
              </div>
              <div>
                <h1 className="text-lg font-bold text-primary">Nabt-Intel</h1>
                <p className="text-xs text-primary/80">Market Intelligence</p>
              </div>
            </Link>
          )}

          {/* Separator */}
          {showLogo && <div className="w-px h-8 bg-border"></div>}

          {/* Page Title and Description */}
          <div className="flex items-center space-x-4">
            <div>
              <h1 className="text-xl font-bold text-foreground">{title}</h1>
              <p className="text-sm text-muted-foreground">{subtitle}</p>
            </div>
          </div>
        </div>

        {/* User info and logout button - only show when not admin (no sidebar) */}
        {showLogo && userName && onLogout && (
          <div className="flex items-center space-x-4">
            <div className="text-right">
              <p className="text-sm font-medium">{userName}</p>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={onLogout}
              className="hover:bg-destructive hover:text-destructive-foreground"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
